let installed = false;

// Same-path query/hash updates do not remount NuxtPage, so leave/enter
// never runs. Covering here would leave the orange curtain stuck.
function isSamePathNavigation(to, from) {
    return to.path === from.path;
}

export function useCoverRouting() {
    if (!import.meta.client || installed) return;
    installed = true;

    const router = useRouter();
    const nuxtApp = useNuxtApp();
    const globalStore = useGlobalStore();
    const { cover, emergencyUncover, isCovered } = useCoverNavigation();

    router.beforeEach(async (to, from) => {
        if (!from.matched.length) return;
        if (!globalStore.appLoadingComplete) return;
        if (to.meta?.noCover) return;
        if (isSamePathNavigation(to, from)) return;

        await cover();
    });

    router.afterEach((_to, _from, failure) => {
        if (failure && isCovered.value) {
            emergencyUncover();
        }
    });

    nuxtApp.hook('app:error', () => {
        if (isCovered.value) emergencyUncover();
    });
}
